import './app.css';
import Header from '../header/Header';

export default function AppContainer(
    {
        children,
        menuRef
    }
)
{
    return (
        <div id="outer-container">
            <Header burgerButtonClick={burgerButtonClick} />
            <div id="app-container">
                {children}
            </div>
        </div>
    );

    function burgerButtonClick() {
        if (!menuRef.current) return;
        menuRef.current.toggle();
    }
}
